const QUESTION_TYPES = [
  'sentiment',
  'text_area',
  'multiple_choice',
  'multi_select'
];

export default QUESTION_TYPES;
